export const ASSET_TYPES = {
  documents: {
    id: 'documents',
    label: 'label.DOCUMENTS'
  },
  images: {
    id: 'images',
    label: 'label.IMAGES'
  },
  videos: {
    id: 'videos',
    label: 'label.VIDEOS'
  }
};

export const IMAGE_UPLOAD_TYPES = {
  single: {
    id: 'single',
    label: 'label.IMAGE_MODAL_SINGLE_UPLOAD'
  },
  bulk: {
    id: 'bulk',
    label: 'label.IMAGE_MODAL_BULK_UPLOAD'
  }
};
